import { defaultTheme } from 'gd-design-library';
import { colors } from './colors';

export const stepper = {
  ...defaultTheme.stepper,
  step: {
    ...defaultTheme.stepper.step,
    default: {
      ...defaultTheme.stepper.step.default,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexShrink: 0,
      gap: '0.5rem',
      minWidth: 'auto'
    },
    complete: {
      cursor: 'default'
    }
  },
  stepIcon: {
    ...defaultTheme.stepper.stepIcon,
    default: {
      ...defaultTheme.stepper.stepIcon.default,
      width: 50,
      height: 50,
      borderWidth: '1px'
    },
    active: {
      ...defaultTheme.stepper.stepIcon.active,
      default: {
        ...defaultTheme.stepper.stepIcon.active.default,
        backgroundColor: colors.primary.default,
        borderColor: colors.primary.default,
        color: colors.neutral.white
      }
    },
    inactive: {
      ...defaultTheme.stepper.stepIcon.inactive,
      default: {
        ...defaultTheme.stepper.stepIcon.inactive.default,
        backgroundColor: 'transparent',
        borderColor: colors.neutral['grey.100'],
        color: colors.neutral['grey.100']
      }
    },
    complete: {
      ...defaultTheme.stepper.stepIcon.complete,
      default: {
        ...defaultTheme.stepper.stepIcon.complete.default,
        backgroundColor: 'transparent',
        borderColor: colors.neutral['grey.100'],
        color: colors.neutral['grey.100'],
        'path': {
          fill: colors.neutral['grey.100']
        }
      }
    }
  },
  stepLabel: {
    ...defaultTheme.stepper.stepLabel,
    default: {
      ...defaultTheme.stepper.stepLabel.default,
      margin: '0'
    },
    complete: {
      ...defaultTheme.stepper.stepLabel.complete,
      fontWeight: '500'
    },
    active: {
      ...defaultTheme.stepper.stepLabel.active,
      fontWeight: '500'
    }
  },
  separator: {
    ...defaultTheme.stepper.separator,
    default: {
      ...defaultTheme.stepper.separator.default,
      top: '25px',
      marginLeft: '8px',
      marginRight: '8px',
      borderTopWidth: '1px',
      borderTopColor: colors.neutral['grey.100']
    },
    complete: {
      'borderTopColor': colors.neutral['grey.100']
    }
  }
};
